import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import c from 'classnames';
import SolidButton from '../../../../../Buttons/SolidButton';
import s from './LargeInputFieldButton.scss';
const LargeInputFieldButton = (_param)=>{
    var { // "approval-green" seems a sensible default going by the spec, so including it for a little boost in dev ux
    variant = 'approval-green', isPostfix } = _param, rest = _object_without_properties(_param, [
        "variant",
        "isPostfix"
    ]);
    return /*#__PURE__*/ React.createElement(SolidButton, _object_spread({
        size: "large",
        className: c(isPostfix && s['postfix']),
        variant: variant
    }, rest));
};
LargeInputFieldButton.displayName = 'LargeInputFieldButton';
export default LargeInputFieldButton;
